import React, { useState, useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import { getCircular } from "../Service/Api";
import LazyLoad from "react-lazyload";

const DatesheetTwo = () => {
  useEffect(() => {
    document.title = "Datesheet - St Peters Convent School Faridabad Haryana";
  }, []);

  const [filterData, setFilteredData] = useState([]);

  const termLogic = (dateString) => {
    const month = new Date(dateString).getMonth() + 1; // 1–12
    return month >= 4 && month <= 9 ? "term1" : "term2";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCircular();
        setFilteredData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const termTwoDatesheet = filterData.filter(
    (item) => item.category === "Datesheet" && termLogic(item.date) === "term2",
  );

  return (
    <>
      <Header />

      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Datesheet</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Datesheet Term Two</h1>
            </div>
          </div>

          <div className="row">
            {termTwoDatesheet.length > 0 ? (
              termTwoDatesheet.map((item, index) => (
                <div className="col-xl-4 col-lg-6" key={index}>
                  <Link
                    to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`}
                    target="_blank"
                  >
                    <div className="sample-blk">
                      <div>
                        <p>{item.title}</p>
                        <span>{item.date}</span>
                      </div>
                      <LazyLoad>
                        <img
                          alt="STPCH"
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                          className="img-fluid"
                        />
                      </LazyLoad>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-lg-4">
                <div className="sample-blk">
                  <div>
                    <p>No Datesheet Available</p>
                    <span>—</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DatesheetTwo;
